const controller = "contractors";

export default {
  controller,
  filter: controller + "/filter",
  map: controller + "/map",
  nameInfo: controller + "/name-info",
  search: controller + "/search",
  basicInfo: (id: number) => controller + "/basic-info/" + id,
};
